<template>
  <div class="row justify-content-between">
    <div>
      <span class="badge badge-secondary" v-if="isToday(task)"  @click.stop>
        <router-link :to="{ name: 'today' }" class="text-warning">
          Today
        </router-link>
      </span>
      <span class="badge badge-light" v-else-if="hasDueDate(task)" @click.stop>
        <router-link :to="{ name: 'calendar' }" class="text-danger">
          {{task.due_date | formatDate}}
        </router-link>
      </span>      
      <span class="badge badge-secondary" v-if="task.tier1 !== null"  @click.stop>
        <router-link :to="{ name: task.tier1 }" class="text-white">
          {{ $t("tier1." + task.tier1 + ".name")}}
        </router-link>
      </span>
      <span class="badge badge-danger" v-if="task.project_id" @click.stop>
        <router-link :to="{ name: 'all_projects' }" class="text-white">
          {{$t('projects.parent')}}
        </router-link>
        <i class="material-icons text-white" style="font-size: 75%">arrow_forward_ios</i>
        <router-link :to="{ name: 'category', params: { id: task.project_area_id } }" class="text-white">
          {{task.project_area_name}}
        </router-link>
        <i class="material-icons text-white" style="font-size: 75%">arrow_forward_ios</i>
        <router-link :to="{ name: 'project', params: { id: task.project_id } }" class="text-white">
          {{task.project_name}}
        </router-link>
      </span>
      <span class="badge badge-light" v-if="task.project_id == null">
        <router-link :to="{ name: 'inbox' }" class="text-muted">
          Inbox
        </router-link>
      </span>
      <span v-for="contact in task.contacts" :key="contact.id" class="badge badge-primary">
        <Contact :contact="contact" v-if="activeContactIdsInclude(contact.id)" />
      </span>
      <span v-for="tag in task.tags" :key="tag.id" class="badge badge-success">
        <Tag :tag="tag" v-if="activeTagIdsInclude(tag.id)" />
      </span>
      <div class="ml-1">
        <span v-if="task.discarded">
          <small class="text-muted">Discarded {{task.discarded_at | formatDateTime}}</small>
        </span>
        <span v-else-if="task.completed && task.journaled">
          <small class="text-muted">Journaled {{task.completed_at | formatDateTime}}</small>
        </span>
        <span v-else-if="task.completed && !task.journaled">
          <small class="text-muted">Completed {{task.completed_at | formatDateTime}}</small>
        </span>
        <span v-else>
          <small class="text-muted">Created {{task.created_at | formatDateTime}}</small>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Tag from "components/Tag";
import Contact from "components/Contact";
import store from "../store";

export default {
  components: {
    Tag,
    Contact,
  },  
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    activeContactIdsInclude(id){
      return store.getters.activeContactIds.includes(id)
    },
    activeTagIdsInclude(id){
      return store.getters.activeTagIds.includes(id)
    },
    isToday(task){
      if(!this.hasDueDate(task)){
        return false;
      }
      return new Date(task.due_date) <= new Date();
    },
    hasDueDate(task){
      if(task.due_date){
        return true
      } else {
        return false
      }
    }
  }
}
</script>
